export enum GuidesAvailable {
  addProject,
  addingProductData,
  addingCreatingConnection,
  optimise,
}
